import React from "react";
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

const LandingPage: React.FC = () => {
  const [filled, setFilled] = useState(false);
  const [drawn, setDrawn] = useState(false);

  useEffect(() => {
    // Trigger draw animation after load
    setTimeout(() => setDrawn(true), 500);
    // Fill after drawing completes
    setTimeout(() => setFilled(true), 2500);
  }, []);

  return (
    <Row className="align-items-center justify-content-center" style={{ height: "80vh" }}>
      <Col className="content-col" xs={4}>
        <div className="svg-simplex-logo-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-simplex-logo ${drawn ? "drawn" : ""} ${filled ? "filled" : ""}`}
            viewBox="0.77 0.92 279.8 51.84"
          >
            <g>
              <path d="M32.14,26.79c-2.59-1.1-5.66-2.03-9.22-2.8-3.07-.72-5.6-1.41-7.6-2.08-1.99-.67-3.47-1.53-4.43-2.58-.96-1.05-1.44-2.49-1.44-4.31,0-2.58.94-4.62,2.81-6.1,1.87-1.48,4.78-2.22,8.71-2.22,1.54,0,3.01.16,4.43.47,1.42.31,2.72.72,3.92,1.22,1.2.5,2.28,1.07,3.24,1.69.96.62,1.73,1.27,2.3,1.94l3.02-5.26c-1.44-1.2-3.02-2.23-4.75-3.1s-3.59-1.54-5.58-2.02c-1.99-.48-4.14-.72-6.44-.72-3.5,0-6.65.57-9.43,1.72-2.78,1.15-4.97,2.85-6.55,5.1s-2.38,5-2.38,8.26c0,2.68.59,4.86,1.76,6.53,1.18,1.68,2.94,3.03,5.29,4.06,2.35,1.03,5.26,1.97,8.71,2.84,3.17.77,5.86,1.53,8.06,2.3,2.21.77,3.88,1.72,5,2.87,1.13,1.15,1.69,2.68,1.69,4.59,0,2.53-1.01,4.45-3.02,5.77-2.02,1.31-4.85,1.97-8.5,1.97-1.92,0-3.79-.2-5.62-.61-1.82-.41-3.52-.95-5.08-1.62-1.56-.67-2.95-1.4-4.18-2.2-1.22-.79-2.22-1.6-2.99-2.41l-3.1,5.47c1.92,1.58,3.98,2.91,6.19,3.96,2.21,1.06,4.55,1.86,7.02,2.41,2.47.55,5,.83,7.6.83s5.09-.28,7.34-.83c2.26-.55,4.22-1.41,5.9-2.58,1.68-1.17,2.99-2.66,3.92-4.45.94-1.79,1.4-3.91,1.4-6.35,0-3.06-.7-5.51-2.09-7.36-1.39-1.84-3.38-3.31-5.98-4.41Z"></path>
              <rect x="48.7" y="1.29" width="6.48" height="51.12"></rect>
              <polygon points="92.77 34.48 74.26 1.29 67.42 1.29 67.42 52.41 73.9 52.41 73.9 13.39 90.82 43.41 94.78 43.41 111.63 13.39 111.63 52.41 118.11 52.41 118.11 1.29 111.34 1.29 92.77 34.48"></polygon>
              <path d="M162.75,6.44c-1.39-1.56-3.02-2.81-4.9-3.74s-3.94-1.4-6.19-1.4h-21.31v51.12h6.48v-18.36h15.26c3.02,0,5.66-.78,7.92-2.34,2.25-1.56,4.01-3.6,5.26-6.12,1.25-2.52,1.87-5.17,1.87-7.96,0-2.02-.38-4-1.15-5.94-.77-1.94-1.85-3.7-3.24-5.26ZM159.47,22.96c-.75,1.63-1.78,2.93-3.1,3.89-1.32.96-2.87,1.44-4.64,1.44h-14.9V7.05h14.47c1.68,0,3.22.46,4.61,1.37,1.39.91,2.52,2.17,3.38,3.78.86,1.61,1.3,3.42,1.3,5.44s-.37,3.7-1.12,5.33Z"></path>
              <polygon
                id="simplex-L"
                points="181.69 1.29 175.2 1.29 175.2 52.41 226.68 52.41 226.68 46.86 181.69 46.65 181.69 1.29"
              ></polygon>
              <polygon
                id="simplex-E"
                points="192.84 36.3 199.33 36.3 199.33 29.01 223.3 29.01 223.3 23.61 199.33 23.61 199.33 7.05 226.9 7.05 226.9 1.29 192.84 1.29 192.84 36.3"
              ></polygon>
              <polygon points="280.57 1.29 273.3 1.29 257.89 22.46 242.48 1.29 235.14 1.29 254.22 27.21 235.72 52.41 243.06 52.41 257.89 31.96 272.72 52.41 280 52.41 261.49 27.21 280.57 1.29"></polygon>
            </g>
          </svg>
          <div className="svg-outer-rotating">
            <div className="svg-simplex-icon-lg">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 850.39 850.39">
                <path
                  fill="gray"
                  d="M787.77,272.02c-19.82-46.86-48.19-88.94-84.32-125.07-36.13-36.13-78.21-64.5-125.07-84.32-48.53-20.53-100.06-30.93-153.18-30.93s-104.65,10.41-153.18,30.93c-46.86,19.82-88.94,48.19-125.07,84.32s-64.5,78.21-84.32,125.07c-20.53,48.53-30.93,100.07-30.93,153.18s10.41,104.65,30.93,153.18c19.82,46.86,48.19,88.94,84.32,125.07,36.13,36.13,78.21,64.5,125.07,84.32,48.53,20.53,100.07,30.93,153.18,30.93s104.65-10.41,153.18-30.93c46.86-19.82,88.94-48.19,125.07-84.32,36.13-36.13,64.5-78.21,84.32-125.07,20.53-48.53,30.93-100.07,30.93-153.18s-10.41-104.65-30.93-153.18ZM264.5,121.65c-5.88,35.37-23.6,103.35-76.7,173.07-38.42,50.45-71.94,76.51-93.29,89.49-3.96,2.41-7.66,4.47-11.07,6.22,11.77-116.6,82.12-216.18,181.06-268.78ZM425.2,768.7c-182.65,0-332.46-143.3-342.92-323.37,27.64-9.35,82.07-37.3,145.3-120.32,23.06-30.27,42.05-62.63,56.76-96.65,7.88,30.25,19.32,64.16,35.88,100.08,28.34,61.47,57.65,125.03,97.82,174.12,47.44,57.98,102.84,86.17,169.35,86.17,60.01,0,118.82-26.5,170.06-76.65.05-.05.11-.11.16-.16-38.53,147.55-172.96,256.78-332.41,256.78ZM721.52,477.28c-42.04,40.78-87.17,61.46-134.13,61.46-51.27,0-92.79-21.55-130.65-67.83-36.13-44.16-64.08-104.78-91.11-163.4-44.86-97.28-48.42-178.66-48.42-202.04,0-2.7.05-4.62.08-5.71,0,0,0,0,0,0,.01-.26.02-.5.03-.71,33.94-11.25,70.2-17.34,107.87-17.34,187.49,0,340.38,150.99,343.46,337.76-7.16,11.28-23.33,34.75-47.13,57.83Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    textAlign: "center" as const,
    padding: "20px",
  },
  header: {
    marginBottom: "20px",
  },
  title: {
    fontSize: "2.5rem",
    margin: "0",
  },
  subtitle: {
    fontSize: "1.2rem",
    color: "#555",
  },
  main: {
    marginTop: "20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "1rem",
    color: "#fff",
    backgroundColor: "#007BFF",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default LandingPage;
